import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	handleFormValueChange,
	handleSectionValueChange,
} from 'actions/customForm/addOrEdit'
import {
	FormControl,
	InputLabel,
	OutlinedInput,
	Select,
	MenuItem,
	withStyles,
	FormHelperText,
	ListItemIcon,
	Tooltip,
} from '@material-ui/core'
import styles from '../Form/styles'
import ColorPicker from '../Form/ColorPicker'

export default connect(
	(state, { value, statePath }) => {
		let theValue = ''

		if (typeof value !== 'undefined') {
			theValue = value
		} else {
			if (typeof statePath === 'function') {
				const statePathValue = statePath(state)
				if (typeof statePathValue !== 'undefined') {
					theValue = statePathValue
				}
			}
		}

		return {
			value: theValue,
			error: /* state.customForm.addOrEdit.values[property].error
      ? state.customForm.addOrEdit.values[property].error
      :  */ null,
		}
	},
	(dispatch) =>
		bindActionCreators(
			{ handleFormValueChange, handleSectionValueChange },
			dispatch,
		),
)(
	withStyles(styles)(
		class TextField extends Component {
			componentDidMount() {
				this.forceUpdate()
			}

			render() {
				const {
					value,
					// handleFormValueChange,
					property,
					label,
					disabled,
					placeholder,
					select,
					items,
					color,
					error,
					classes,
					selectTemplate,
					type,
					sectionID,
					handleSectionValueChange,
					fieldType,
					inputComponent,
				} = this.props

				const handleChange = this.props.handleChange || handleSectionValueChange

				return (
					<FormControl
						fullWidth
						variant="outlined"
						disabled={disabled}
						error={Boolean(error)}
					>
						<InputLabel
							ref={(ref) => {
								this.labelRef = ReactDOM.findDOMNode(ref)
							}}
							htmlFor={`formTextField${label}`}
							shrink
							style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
						>
							{label}
						</InputLabel>
						{select ? (
							<Select
								value={value}
								onChange={(e) =>
									handleChange({
										property,
										value: e?.target?.value || '',
										type,
										id: sectionID,
									})
								}
								input={
									<OutlinedInput
										labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
										id={`formTextField${label}`}
										classes={{
											notchedOutline: classes.notchedOutline,
										}}
									/>
								}
							>
								{selectTemplate
									? items.map((item) => selectTemplate(item))
									: items.map((item, idx) => {
											const Icon = item?.Icon

											const menuItem = (
												<MenuItem
													key={`formsFormValue${item.value}${sectionID}${idx}menuItem`}
													value={item.value}
													disabled={item.disabled}
												>
													{Icon && (
														<ListItemIcon
															classes={{ root: classes.listItemIconRoot }}
														>
															<Icon />
														</ListItemIcon>
													)}
													{item.label}
												</MenuItem>
											)

											return item.tooltip ? (
												<Tooltip
													key={`formsFormValue${item.value}${sectionID}${idx}tooltip`}
													title={item.tooltip}
												>
													<div>{menuItem}</div>
												</Tooltip>
											) : (
												menuItem
											)
									  })}
							</Select>
						) : (
							<OutlinedInput
								type={fieldType ? 'number' : 'string'}
								id={`formTextField${label}`}
								labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
								value={value}
								onChange={(e) =>
									handleChange({
										property,
										value:
											fieldType === 'int'
												? parseInt(e?.target?.value)
												: fieldType === 'float'
												? parseFloat(e?.target?.value)
												: e?.target?.value || '',
										type,
										id: sectionID,
									})
								}
								placeholder={placeholder}
								notched
								classes={{
									notchedOutline: classes.notchedOutline,
								}}
								// onKeyDown={}
								onPaste={(e) => {
									if (fieldType) {
										const pastedText = e.clipboardData.getData('Text')
										e.preventDefault()
										if (typeof pastedText === 'string') {
											let modifiedText = pastedText
												.replace(/[^0-9]+/g, '')
												.trim()
											const difference = modifiedText.length - 10
											if (difference > 0) {
												modifiedText = modifiedText.slice(difference)
											}

											handleChange({
												property,
												value:
													fieldType === 'int'
														? parseInt(modifiedText)
														: fieldType === 'float'
														? parseFloat(modifiedText)
														: modifiedText,
												type,
												id: sectionID,
											})
										}
									}
								}}
								endAdornment={
									color ? (
										<ColorPicker
											value={value}
											handleFormValueChange={(value) =>
												handleChange({
													property,
													value,
													type,
													id: sectionID,
												})
											}
										/>
									) : null
								}
								inputComponent={inputComponent}
							/>
						)}
						<FormHelperText error={Boolean(error)}>{error}</FormHelperText>
					</FormControl>
				)
			}
		},
	),
)
